import React from 'react';
import { SV } from '../../../types/rest/mockServiceTypes';
import BzmIcon from '../../icons/BzmIcon';
import i18n from '../../../i18n';

interface StartMsBtnProps {
  disabled: boolean;
  onClick: () => void;
  id: string | number;
}

const StartMockBtn = ({ id, onClick, disabled }: StartMsBtnProps) => {
  return (
    <button
      disabled={disabled}
      id={`mockServiceStatusRunMockServiceButton` + id}
      className="btn btn-success btn-square"
      title={i18n.t('mockServices:mockServicesTable.runMockServiceTitle')}
      onClick={onClick}
    >
      <BzmIcon variant={'icon-bzm-play-run'} />
    </button>
  );
};

export default StartMockBtn;
